import { getDate, getHours, getMinutes, getMonth, getYear, setHours, setMinutes } from 'date-fns';

import { MAIN_CATEGORIES } from '@autos/auto-results/constants/categories';
import { transformIsoDate } from '@search-bar/mappers/autos-iso-date.mapper';

export function formatDateTime(date: Date, time?: string): string {
  const mm = twoDigits(getMonth(date) + 1);
  const dd = twoDigits(getDate(date));
  const hh = twoDigits(getHours(date));
  const min = twoDigits(getMinutes(date));
  if (time) {
    time = (time.includes('AM') || time.includes('PM')) ? convertTime24h(time) : time;
    return `${getYear(date)}-${mm}-${dd}T${time}:00.000`;
  }
  return `${getYear(date)}-${mm}-${dd}T${hh}:${min}:00.000`;
}

export function stringToDate(str: string): Date {
  return new Date(str.replace('Z', ''));
}

export function setDateTime(date: Date, time: string): Date {
  const auxTime = convertTime24h(time).split(':');
  date = setHours(date, Number(auxTime[0]));
  date = setMinutes(date, Number(auxTime[1]));
  return date;
}

function twoDigits(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

// convert from AM / PM to 24h
export function convertTime24h(time: string): string {
  let res = '';
  const aux = time.split(' ');
  const aux2 = aux[0].split(':');
  const hh = aux2[0];
  const mm = aux2[1];
  let nH = Number(hh);
  if (aux[1] === 'PM') {
    nH = (nH === 12) ? nH : nH + 12;
  } else {
    nH = (nH === 12) ? 0 : nH;
  }
  res = `${twoDigits(nH)}:${mm}`;
  return res;
}

export function convertTime12h(time: string): string {
  let res = '';
  const aux = time.split(' ');
  const aux2 = aux[0].split(':');
  let hh = Number(aux2[0]);
  const mm = Number(aux2[1]);
  let period = 'AM';
  if (hh === 0) hh = 12;
  else if (hh === 12) period = 'PM';
  else if (hh > 12) {
    period = 'PM';
    hh = hh - 12;
  }
  res = `${twoDigits(hh)}:${twoDigits(mm)} ${period}`;
  return res;
}

export function getParentCategory(subcategory: string): string {
  const foundIdx = MAIN_CATEGORIES.findIndex(category =>
    category.subcategories.find((sub) => (sub) ? sub.toUpperCase() === subcategory.toUpperCase() : false));
  return (foundIdx === -1) ? '' : MAIN_CATEGORIES[foundIdx].name;
}

export function removeTime(timedate: Date | string): Date {
  if (typeof timedate === 'string') timedate = new Date(transformIsoDate(timedate));
  return new Date(timedate.getFullYear(), timedate.getMonth(), timedate.getDate(), 0, 0, 0);
}

export function getTime(timedate: Date | string): string {
  if (typeof timedate === 'string') timedate = new Date(timedate);
  return `${twoDigits(timedate.getHours())}:${twoDigits(timedate.getMinutes())}`;
}
